// extracted by mini-css-extract-plugin
module.exports = {"component":"container_component__wiggy","isFullWidth":"container_isFullWidth__moYJG"};